import { Card, Stack, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Strings } from '@app/constants';
import { Scrollbar } from '@app/components';
import { UserCard } from '@app/components/card';
import { useRequestState } from '@app/hooks';
import {
  getDashboardData,
  getProjectContribution,
  selectDashboardState,
  selectGetProjectContribution,
  getMyProjectLeaders,
  getRemainingTasks,
  selectGetRemainingTaskState,
} from '@app/modules/dashboard';
import {
  EmployeeLeavesStatus,
  EmployeeOverdueTasks,
  EmployeeProgress,
  EmployeeProjectsOverview,
} from '@app/modules/employee-dashboard';
import { InternTasksAndTeamLeadersPage } from './Intern-tasks-and-teamLeaders';
import { selectMyProfileFormState } from '@app/modules/my-profile';

const InternDashboardPage = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDashboardData());
    dispatch(getProjectContribution({ userId: myProfile?.id }));
  }, [dispatch]);

  const { data } = useRequestState({
    stateSelector: selectDashboardState,
    errorShown: true,
  });

  const { data: remainingTaskData } = useRequestState({
    stateSelector: selectGetRemainingTaskState,
    errorShown: true,
  });

  const { data: project } = useRequestState({
    stateSelector: selectGetProjectContribution,
    errorShown: true,
  });

  const fullName: string =
    (String(data?.userForDashboard?.firstName) ?? '') +
    ' ' +
    (String(data?.userForDashboard?.lastName) ?? '');

  const { data: myProfile } = useRequestState({
    stateSelector: selectMyProfileFormState,
  });

  useEffect(() => {
    if (myProfile) {
      dispatch(getMyProjectLeaders({ status: 'remain', userId: myProfile?.id }));
      dispatch(getRemainingTasks({ userId: myProfile?.id }));
    }
  }, [myProfile, dispatch]);

  return (
    <>
      <Scrollbar>
        <Stack flexDirection={{ sm: 'column', md: 'row' }} mt={2}>
          <Card
            sx={{
              ml: { md: 2, xs: 1 },
              mr: { xs: 1, md: 1 },
              mb: 2,
              width: { md: '60%', sm: '97%' },
              borderRadius: '5px',
              backgroundImage: 'url(/assets/images/dashboard-background.png)',
              backgroundSize: 'auto',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          >
            <Stack fontSize={18} fontWeight={700} m={'20px 0px 4px 20px'}>
              {Strings.common.welcomeBackCaption(fullName)}
            </Stack>
            <Stack direction={'row'} mb={2} justifyContent="space-between" mr={3}>
              <Stack
                width={'350px'}
                m={'15px 0px 15px 20px'}
                color={theme.palette.grey[600]}
                fontSize={14}
              >
                {Strings.employeeDashborad.caption}
              </Stack>
              <Stack justifyContent="center" display={{ xs: 'none', md: 'inline' }} mt={-6}>
                <img
                  src={'/assets/images/dashboard-icon.png'}
                  style={{
                    objectFit: 'contain',
                    height: '200px',
                    width: '200px',
                    alignItems: 'center',
                  }}
                />
              </Stack>
            </Stack>
          </Card>

          <Stack sx={{ width: { md: '40%', xs: '98%' } }} mr={{ md: 2, xs: 1 }}>
            <Stack direction={{ md: 'row', xs: 'row' }} width={{ xs: '100%' }}>
              <UserCard
                title={Strings.field.joinDate}
                value={data?.userForDashboard?.joiningDate}
                iconImg="ic_joiningDate"
                width={{ md: '100%', xs: '50%' }}
              />
              <UserCard
                title={Strings.dashboard.duration}
                value={'4 Months'}
                iconImg="ic_duration"
                width={{ md: '100%', xs: '50%' }}
              />
            </Stack>
            <Stack flexDirection={{ md: 'row', xs: 'row' }}>
              <UserCard
                title={Strings.dashboard.department}
                iconImg="ic_department"
                workedFor={data?.userForDashboard?.department}
                width={{ md: '100%', xs: '50%' }}
              />
              <UserCard
                title={Strings.dashboard.designation}
                value={data?.userForDashboard?.designation}
                iconImg="ic_designation"
                width={{ md: '100%', xs: '50%' }}
              />
            </Stack>
          </Stack>
        </Stack>
        <EmployeeProjectsOverview data={data} />
        <InternTasksAndTeamLeadersPage remainingTaskData={remainingTaskData} />
        <EmployeeOverdueTasks />
        <EmployeeProgress holidays={data?.holidays} project={project} />
        <EmployeeLeavesStatus data={data} />
      </Scrollbar>
    </>
  );
};

export { InternDashboardPage };
